<template>
  <nav class="navbar">
    <div id="navbarInner" class="navbar-inner">
      <ul class="navbar-menu">
        <StorageMenuOldNavigationNavbarFirstLevel
          v-for="(item, i) in links"
          :key="i"
          :is-open="i === activeFirstLevel"
          :is-mobile-open="isMobileOpen && i === activeFirstLevel"
          :active-first-level="activeFirstLevel"
          :is-mobile="isMobile"
          v-bind="item"
          @mouseenter="onEnter(i)"
          @touchend="onClickMobile(i)"
        />
      </ul>

      <Transition name="overlay-fade">
        <div
          v-if="isMobileOpen && isMobile"
          class="navbar-first-overlay"
          @touchend="onCloseMobile"
        />
      </Transition>
    </div>
  </nav>
  <Teleport to="body">
    <Transition name="fade-absolute">
      <div
        v-if="activeFirstLevel !== -1 && !isMobile"
        class="fixed top-0 left-0 w-screen h-screen bg-black/80 z-300 backdrop-blur-2xl"
        @click="onClose"
      />
    </Transition>
  </Teleport>
</template>

<script lang="ts" setup>
import type { NavbarFirstLevelItem } from '../../helper'

const { isMobile } = useViewport()
withDefaults(
  defineProps<{
    links: NavbarFirstLevelItem[]
  }>(),
  {
    links: () => [],
  },
)

const emit = defineEmits(['closeMobileMenu'])

const activeFirstLevel = ref<number>(-1)
const route = useRoute()
const isMobileOpen = ref<boolean>(false)
const subtreeIndex = useSubtreeIndex()

function onEnter(index: number) {
  if (isMobile.value) {
    return
  }
  activeFirstLevel.value = index
}

function onClose() {
  activeFirstLevel.value = -1
}

function onClickMobile(index: number) {
  if (!isMobile.value) {
    return
  }

  if (activeFirstLevel.value === -1) {
    activeFirstLevel.value = index
    isMobileOpen.value = true
  }
}

function onCloseMobile() {
  if (subtreeIndex.value !== -1) {
    subtreeIndex.value = -1
    return
  }

  if (activeFirstLevel.value !== -1) {
    activeFirstLevel.value = -1
    isMobileOpen.value = false
  }
}

watch(
  () => route.fullPath,
  () => {
    setTimeout(() => {
      onClose()

      if (isMobile.value) {
        emit('closeMobileMenu')
      }
    }, 250)
  },
)
</script>

<style lang="postcss">
.navbar {
  @apply belowDesktop:fixed belowDesktop:bottom-0 belowDesktop:right-0 belowDesktop:top-0 belowDesktop:w-3/5 belowDesktop:overflow-hidden belowDesktop:bg-background;
  @apply desktop:!block;
  @apply belowTablet:fixed belowTablet:bottom-0 belowTablet:right-0 belowTablet:top-0 belowTablet:!w-full belowTablet:overflow-hidden belowTablet:bg-background;
  @screen belowTablet {
    z-index: 200;
  }

  @screen belowDesktop {
    z-index: 200;
  }
}
.navbar-menu {
  @apply tablet:border-t tablet:border-solid tablet:border-border;
  @apply desktop:m-0 desktop:flex desktop:border-0 desktop:pt-0;
  padding-top: 3rem;
  @screen tablet {
    padding-top: 1rem;
    margin-top: 5rem;
  }
}
</style>
